import React from 'react';
import PropTypes from 'prop-types';

import Cards from './components/Cards';

const CashbacksData = (props) => {
  const { cashbacksData, loadingState } = props;

  return (
    <div className="transactions-filters">
      <div className="form-header">
        <h4>Report Data</h4>
      </div>
      <Cards cashbacksData={cashbacksData} loadingState={loadingState} />
    </div>
  );
};

export default CashbacksData;

CashbacksData.propTypes = {
  cashbacksData: PropTypes.shape({
    cashbacksCount: PropTypes.number.isRequired,
    netCashbacksAmount: PropTypes.number.isRequired,
    earnedCashbacksAmount: PropTypes.number.isRequired,
    refundCashbacksAmount: PropTypes.number.isRequired,
    spentCashbacksAmount: PropTypes.number.isRequired,
  }),
  loadingState: PropTypes.string.isRequired,
};

CashbacksData.defaultProps = {
  cashbacksData: null,
};
